import { request } from '@/utils/ajax';
import { ProjectDeadlineUpdateInfo } from './projects';
import { ProjectDeadline } from '@/types';

export function saveProjectDeadline(data: ProjectDeadlineUpdateInfo): Promise<ProjectDeadline> {
    return request(`api/deadline`, {
        method: 'POST',
        json: true,
        body: data,
    }).then((x) => x.json());
}

export function deleteProjectDeadline(deadlineId: number): Promise<any> {
    return request(`api/deadline/${deadlineId}`, {
        method: 'DELETE',
        json: true,
    });
}